import { render, staticRenderFns } from "./ClaimOrgAccountPage.vue?vue&type=template&id=120be4fe&scoped=true&"
import script from "./ClaimOrgAccountPage.vue?vue&type=script&lang=js&"
export * from "./ClaimOrgAccountPage.vue?vue&type=script&lang=js&"
import style0 from "./ClaimOrgAccountPage.vue?vue&type=style&index=0&id=120be4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120be4fe",
  null
  
)

export default component.exports